import { REPUB_CONFIG } from '@cx-web/repub-config';
import { getRepubMetaFromRepub, isOcPlusRepub } from '@cx-web/utils';

import { type Repub } from '@cx-modules/constants';

export function getTipsterLink(repub: Repub) {
  if (!isOcPlusRepub(repub)) return;
  const { repubPath } = getRepubMetaFromRepub(repub);
  const urlPrefix = `${repubPath}/plus`;
  const tipstersPath = REPUB_CONFIG[repub]?.plus?.tipsters?.path;
  return `${urlPrefix}/${tipstersPath}`;
}
